function validateForm() {
    const formData = new FormData();
    const name = document.getElementById('contact-input-name').value;
    const email = document.getElementById('contact-input-email').value;
    const phone = document.getElementById('contact-input-phone').value;
    const content = document.getElementById('contact-input-content').value;
    if (!email && !phone) {
        alert("Podaj adres email lub numer telefonu aby\u015Bmy mogli si\u0119 z Tob\u0105 skontaktowa\u0107");
        throw 'No contact details';
    }
    for(var x = 0; x < allFiles.length; x++)formData.append("fileToUpload[]", allFiles[x]);
    formData.append('company_name', name);
    formData.append('email', email);
    formData.append('phone', phone);
    formData.append('message', content);
    return formData;
}
async function sendEmail() {
    if (!document.getElementById('contact-form').classList.contains('idle')) return;
    const formData = validateForm();
    document.getElementById('contact-form').classList = [
        'sending'
    ];
    customScrollIntoView('contact');
    fetch('/ask/', {
        method: 'post',
        body: formData
    }).then(()=>{
        // Send
        document.getElementById('contact-form').classList = [
            'send'
        ];
    }).catch(()=>{
        document.getElementById('contact-form').classList = [
            'failed'
        ];
    });
}
let allFiles = [];
function initDropZone() {
    Dropzone.options.myDropzone = {
        paramName: "file",
        maxFilesize: 10,
        dictDefaultMessage: "Kliknij lub przeci\u0105gnij plik",
        addRemoveLinks: true,
        dictRemoveFile: "Usu\u0144",
        autoProcessQueue: false,
        init: function() {
            this.on("removedfile", function(file, response) {
                allFiles = allFiles.filter((e)=>e !== file);
            });
            this.on("addedfile", (file)=>{
                allFiles.push(file);
            });
        }
    };
}
if (typeof Dropzone !== 'undefined') initDropZone();

//# sourceMappingURL=landing.a341ddf8.js.map
